import coordtransform from '@/WGS84.js'

/** 灵动模块约定：接口与内部模型统一 WGS84，页面坐标输入、显示及高德地图使用 GCJ02。 */
export function parseLonLat(value) {
  const parts = String(value || '').trim().split(',')
  if (parts.length !== 2 || parts.some(item => !item.trim())) return null
  const values = parts.map(Number)
  return values.length === 2 && values.every(Number.isFinite)
    && Math.abs(values[0]) <= 180 && Math.abs(values[1]) <= 90 ? values : null
}

export function formatLonLat(point) {
  if (!Array.isArray(point) || point.length !== 2 || !point.every(Number.isFinite)) return ''
  return `${Number(point[0]).toFixed(6)},${Number(point[1]).toFixed(6)}`
}

/** 后端 WGS84 坐标转高德地图 GCJ02 坐标。 */
export function wgs84ToGcj02Point(point) {
  if (!Array.isArray(point) || point.length !== 2 || !point.every(Number.isFinite)) return null
  return coordtransform.wgs84togcj02(Number(point[0]), Number(point[1]))
}

/** 高德地图 GCJ02 坐标转后端 WGS84 坐标。 */
export function gcj02ToWgs84Point(point) {
  if (!Array.isArray(point) || point.length !== 2 || !point.every(Number.isFinite)) return null
  return coordtransform.gcj02towgs84(Number(point[0]), Number(point[1]))
}

export function wgs84LonLatToGcj02Point(value) {
  const point = parseLonLat(value)
  return point ? wgs84ToGcj02Point(point) : null
}

export function gcj02PointToWgs84LonLat(lng, lat) {
  const point = gcj02ToWgs84Point([Number(lng), Number(lat)])
  return point ? formatLonLat(point) : ''
}

export function wgs84RouteToGcj02(value) {
  return String(value || '').split('|').map((item) => wgs84LonLatToGcj02Point(item)).filter(Boolean)
}

export function gcj02RouteToWgs84(points) {
  return (points || []).map((point) => gcj02ToWgs84Point(point)).filter(Boolean).map(formatLonLat).join('|')
}

/** 数据库点串仅在展示时转换，不修改原始坐标。 */
export function wgs84RouteToGcj02Text(value) {
  return wgs84RouteToGcj02(value).map(formatLonLat).join('|')
}
